(function () {
  angular.module("akitabox.ui.components.typeAheadDynamicInput", [
    "akitabox.ui.components.typeAheadInput",
  ]);
})();
